import { toast as hotToast } from 'react-hot-toast';

export const toast = {
  success: (msg, opts) => hotToast.success(msg, opts),
  error: (msg, opts) => hotToast.error(msg, opts),
  info: (msg, opts) => hotToast(msg, opts),
  loading: (msg, opts) => hotToast.loading(msg, opts),
  dismiss: (toastId) => hotToast.dismiss(toastId),
};

export default toast; 
